// Copyright (c) 2024, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 LLC. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.

import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ConnectorName } from "../types/types";

const connectorNameSlice = createSlice({
  name: "connectorName",
  initialState: [] as ConnectorName[],
  reducers: {
    setConnectorNames: (state, action: PayloadAction<ConnectorName[]>) => action.payload,
  },
});

export const { setConnectorNames } = connectorNameSlice.actions;

export default connectorNameSlice.reducer;
